export default __webpack_public_path__ + "static/media/IBMCheckboxUndeterminate.f192cb74.svg";